module.exports = __webpack_public_path__ + "assets/media/s08.fce0b544.mp3";